export default __webpack_public_path__ + "static/media/team8.9e74fe7e.png";